 

import type { RouteObject } from 'react-router';
import { lazyRoute } from '../utils/lazyRoute.js';

const IntegrationRoutes: RouteObject[] = [
  {
    path: 'INT/HomePage',
    lazy: lazyRoute(() => import('../../pages/Integration/Index/Index.js'))
  },
  {
    path: 'INT/Integration',
    lazy: lazyRoute(() => import('../../pages/Integration/Index/Index.js'))
  },
  {
    path: 'INT/IntegrationZatca',
    lazy: lazyRoute(() => import('../../pages/Integration/IntegrationZatca/Index.js'))
  }
];

export default IntegrationRoutes;

